import { EnumFileExtension } from '../api/Pioneer/enums/enumFileExtension'

export const getEnumFileExtension = (ext: string | undefined): EnumFileExtension => {
  switch (ext) {
    case 'pdf':
      return EnumFileExtension.PDF
    case 'xml':
      return EnumFileExtension.XML
    case 'xsig':
      return EnumFileExtension.XSIG
    case 'xlsm':
      return EnumFileExtension.XLSM
    case 'xlsx':
      return EnumFileExtension.XLSX
    default:
      return EnumFileExtension.HTML
  }
}

export const fileDownloadHelper = (fileName: string, file: File) => {
  const anchor = window.document.createElement('a')
  anchor.href = window.URL.createObjectURL(file)
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  window.URL.revokeObjectURL(anchor.href)
}

export const normalizeFilename = (filename: string): string => {
  return filename
    .toLowerCase()
    .normalize('NFD') // separa caracteres con tilde
    .replace(/[\u0300-\u036f]/g, '') // elimina acentos
    .replace(/\s+/g, '-') // reemplaza espacios por guión medio
    .replace(/[\/\\:*?"<>|]/g, '') // elimina caracteres inválidos de Windows
    .replace(/[–—”“‘’]/g, '') // elimina guiones largos y comillas curvas
    .replace(/[^a-z0-9-]/g, '') // elimina cualquier otro símbolo no alfanumérico
    .replace(/-+/g, '-') // evita múltiples guiones seguidos
    .replace(/^-+|-+$/g, '') // elimina guiones iniciales/finales
}
